import moment from 'moment';
import { getNextBusinessDay } from 'utils/dateHelper';

const DAYS_IN_WEEK = 7;
// Bounded lookahead so a misconfigured schedule can never loop forever.
const MAX_LOOKAHEAD = 60;

function isBeforeCutoff(order, cutoffTime) {
  if (!cutoffTime) return true;
  const [hour, minute] = String(cutoffTime).split(':').map((part) => parseInt(part, 10));
  if (Number.isNaN(hour)) return true;
  const cutoff = order.clone().set({ hour, minute: minute || 0, second: 0, millisecond: 0 });
  return order.isBefore(cutoff);
}

// Walk forward counting only open days (delay > 0), skipping closed ones.
function advanceOpenDays(order, delays, targetOpenDays) {
  const date = order.clone();
  let openCount = 0;
  for (let i = 0; i < MAX_LOOKAHEAD; i += 1) {
    date.add(1, 'day');
    if (delays[date.day()] > 0) {
      openCount += 1;
      if (openCount >= targetOpenDays) return date;
    }
  }
  return date;
}

// Default delivery date for a feed order.
// settings: { enabled, cutoffTime: 'HH:MM', dayDelays: [Sun..Sat] }.
// When disabled or misconfigured, falls back to the legacy next-business-day rule.
export function getFeedDefaultDeliveryDate(orderMoment = moment(), settings = {}) {
  const order = orderMoment.clone();
  const { enabled, cutoffTime, dayDelays } = settings;

  if (!enabled || !Array.isArray(dayDelays) || dayDelays.length !== DAYS_IN_WEEK) {
    return getNextBusinessDay(order);
  }

  const delays = dayDelays.map((day) => Number(day) || 0);
  if (!delays.some((day) => day > 0)) return getNextBusinessDay(order);

  // Before cutoff: next open day. After cutoff: the order day's delay, counted in open days.
  // A 0 on the order's own day (mill closed) still resolves to the next open day.
  const targetOpenDays = isBeforeCutoff(order, cutoffTime)
    ? 1
    : Math.max(delays[order.day()], 1);

  return advanceOpenDays(order, delays, targetOpenDays);
}
